var Notification = function(params){
    var self = this;
    self.id = ko.observable(params && params.id || 0);
    self.type = ko.observable(params && params.type || 'info');
    self.content = ko.observable(params && params.content || '');
    self.source = ko.observable(params && params.source || '');
    self.unread = ko.observable(params && params.unread || 0);
    self.created = ko.observable(params && params.created || '');

    self.isUnread = ko.pureComputed(function(){ return self.unread() == 1; });
};
